// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  implementation: 'web',
  firebaseConfig : {
    apiKey: 'AIzaSyCcEIVzzDzVSyiqudA86y45UV7Idw8ise0',
    authDomain: 'parknha.firebaseapp.com',
    projectId: 'parknha',
    storageBucket: 'parknha.appspot.com',
    messagingSenderId: '139595443362',
    appId: '1:139595443362:web:0f4fe9bfa2c4a88cb77bfb',
    measurementId: 'G-5Y1SW4V2K5'
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
